import React from 'react';
import { Drawer, Button, Slider } from 'antd';
import { HiXMark } from 'react-icons/hi2';

const PriceFilter = ({
  open,
  onCancel,
  minPrice,
  maxPrice,
  currentMinPrice,
  currentMaxPrice,
  selectedVariants,
  availableVariants,
  onChange,
  onVariantChange,
  onClick,
  user,
  resetFilter,
}) => {
  const hasVariants =
    availableVariants && Object.keys(availableVariants).length > 0;
  const hasActiveFilters =
    Object.keys(selectedVariants || {}).length > 0 ||
    currentMinPrice !== minPrice ||
    currentMaxPrice !== maxPrice;

  return (
    <Drawer
      open={open}
      onClose={onCancel}
      placement="bottom"
      height="auto"
      closable={false}
      className="ls-filter-drawer"
      bodyStyle={{ padding: 0 }}
      style={{ borderRadius: '24px 24px 0 0', overflow: 'hidden' }}
    >
      {/* ── handle bar ── */}
      <div className="ls-filter-drawer__handle" />

      {/* ── header ── */}
      <div className="ls-filter-drawer__header">
        <span className="ls-filter-drawer__title">Filter &amp; Sort</span>
        <button
          type="button"
          className="ls-filter-drawer__close"
          onClick={onCancel}
          aria-label="Close filter"
        >
          <HiXMark />
        </button>
      </div>

      <div className="ls-filter-drawer__body">
        {/* ── Price range ── */}
        <section className="ls-filter-section">
          <p className="ls-filter-section__label">Price range</p>
          <div className="ls-filter-price-range">
            <span className="ls-filter-price-range__pill">
              {user?.currency}{currentMinPrice}
            </span>
            <span className="ls-filter-price-range__sep">–</span>
            <span className="ls-filter-price-range__pill">
              {user?.currency}{currentMaxPrice}
            </span>
          </div>
          <div className="ls-filter-slider-wrap">
            <Slider
              min={minPrice}
              max={maxPrice}
              range
              step={2}
              value={[currentMinPrice, currentMaxPrice]}
              onChange={onChange}
            />
          </div>
        </section>

        {/* ── Variant filters ── */}
        {hasVariants && (
          <section className="ls-filter-section">
            <p className="ls-filter-section__label">Options</p>
            {Object.keys(availableVariants).map((variantType) => (
              <div key={variantType} className="ls-filter-variant-group">
                <p className="ls-filter-variant-group__name">{variantType}</p>
                <div className="ls-filter-pills">
                  {availableVariants[variantType].map((value, idx) => {
                    const isSelected = selectedVariants[variantType] === value;
                    return (
                      <button
                        key={idx}
                        type="button"
                        className={`ls-filter-pill${isSelected ? ' ls-filter-pill--active' : ''}`}
                        onClick={() =>
                          onVariantChange(variantType, isSelected ? undefined : value)
                        }
                      >
                        {value}
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </section>
        )}
      </div>

      {/* ── sticky footer ── */}
      <div className="ls-filter-drawer__footer">
        <button
          type="button"
          className={`ls-filter-footer__reset${hasActiveFilters ? ' is-active' : ''}`}
          onClick={resetFilter}
          disabled={!hasActiveFilters}
        >
          Reset{hasActiveFilters ? ' ·' : ''}
          {hasActiveFilters
            ? ` ${Object.keys(selectedVariants || {}).length + (currentMinPrice !== minPrice || currentMaxPrice !== maxPrice ? 1 : 0)} active`
            : ''}
        </button>
        <Button
          type="primary"
          size="large"
          block
          onClick={onClick}
          className="ls-filter-footer__apply"
        >
          Show results
        </Button>
      </div>
    </Drawer>
  );
};

export default PriceFilter;